export const GetContext = Symbol('getContext');
const ActionName = Symbol('name');
export const ActionGetContext = Symbol('getContext');
export const ActionMessageSid = Symbol('messageSid');
export const ActionSetMessageSid = Symbol('setMessageSid');
export const ActionSetMessageSids = Symbol('setMessageSids');
export const ActionSetName = Symbol('setName');
export default class Action {
    addTypeToContext(o) {
        const result = Object.assign({ createdAt: new Date(), type: this.constructor.name, actionName: this[ActionName] }, o);
        if (this[ActionMessageSid]) {
            result.messageSid = this[ActionMessageSid];
        }
        return result;
    }
    get name() {
        return this[ActionName];
    }
    get sid() {
        return this[ActionMessageSid];
    }
    [ActionGetContext]() {
        return this.addTypeToContext(this[GetContext]());
    }
    [ActionSetMessageSid](sid) {
        this[ActionMessageSid] = sid;
    }
    [ActionSetMessageSids](sids) {
        this[ActionMessageSid] = sids;
    }
    [ActionSetName](name) {
        this[ActionName] = name;
    }
}
